/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1PublishinglistsQueryResponse } from '../../types/GetV1Publishinglists.ts'

export const getV1PublishinglistsQueryKey = () => [{ url: '/v1/PublishingLists' }] as const

export type GetV1PublishinglistsQueryKey = ReturnType<typeof getV1PublishinglistsQueryKey>

/**
 * {@link /v1/PublishingLists}
 */
export async function getV1Publishinglists(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetV1PublishinglistsQueryResponse,
        ResponseErrorConfig<Error>,
        unknown
    >({ method: 'GET', url: `/v1/PublishingLists`, ...requestConfig })
    return res
}

export function getV1PublishinglistsQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1PublishinglistsQueryKey()
    return queryOptions<
        ResponseConfig<GetV1PublishinglistsQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1PublishinglistsQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Publishinglists(config)
        },
    })
}

/**
 * {@link /v1/PublishingLists}
 */
export function useGetV1Publishinglists<
    TData = ResponseConfig<GetV1PublishinglistsQueryResponse>,
    TQueryData = ResponseConfig<GetV1PublishinglistsQueryResponse>,
    TQueryKey extends QueryKey = GetV1PublishinglistsQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1PublishinglistsQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1PublishinglistsQueryKey()

    const query = useQuery(
        {
            ...getV1PublishinglistsQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
